// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticlePageBlok_root__521lN","articleBreadcrumbs":"ArticlePageBlok_articleBreadcrumbs__VVfqG"};